import React from 'react';
import { Alert } from 'react-bootstrap';
import { Modal, Button } from 'react-bootstrap';

const ConfirmDeleteModal = ({ show, onHide, onConfirm, deleting, error }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton style={{ margin: '0px', padding: '30px', paddingBottom: '0px' }}>
            <Modal.Title className="m-0">Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
            <i className="fas fa-exclamation-triangle fa-3x text-danger mb-3"></i>
            <p className="m-0">¿Estás seguro de que deseas eliminar este elemento?</p>
            {error && error.response && error.response.data &&
                <Alert className="mb-0 mt-3" variant="danger">{error.response.data.error || "Hubo al eliminar este blog."}</Alert>
            }
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none',  padding: '30px', paddingTop: '0px' }}>
            <Button variant="secondary" onClick={onHide}>
                Cancelar
            </Button>
            <Button variant="danger" onClick={onConfirm} disabled={deleting}>
                {deleting ? 'Eliminando...' : 'Eliminar'}
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ConfirmDeleteModal;